import { Button } from '@mui/material';
const ErrorPage = ({ error }) => {
  const pageStyle = {
    height: '90vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    fontFamily: 'sans-serif'
  };
  const imgStyle = {
    width: '50%'
  };

  const errorStyle = {
    maxHeight: '250px',
    maxWidth: '500px',
    overflowY: 'scroll'
  };

  return (
    <div style={pageStyle}>
      <h1
        style={{
          margin: '0',
          padding: '0'
        }}
      >
        Oops! Something went wrong.
      </h1>
      <p>Please contact your administrator</p>
      <img src="/images/error.jpg" alt={error?.message || error?.error} style={imgStyle} />
      <Button variant="contained" color="incorta" onClick={() => (window.location.href = '/')}>
        Home
      </Button>
      <details style={errorStyle}>
        <summary>Show Error Stack</summary>
        <ul>
          {typeof error == 'object' &&
            Object.entries(error).map(([key, value]) => (
              <li key={key}>
                <strong>{key.toUpperCase()}:</strong> {JSON.stringify(value)}
              </li>
            ))}
        </ul>
      </details>
    </div>
  );
};

export default ErrorPage;
